<template>
  <div>
    <section v-if="!loading">
      <Title class="mb-4">{{ category.title }}</Title>
      <div class="article-widget-list d-flex flex-column">
        <ArticleCard
          v-for="({ id, title, img, category, date }, i) in items"
          :key="i"
          :id="id"
          :title="title"
          :img="img"
          :date="date"
          :category-title="category.title"
          :category-color="category.color"
          :type="i === 0 ? 'featured' : 'small'"
        />
      </div>
    </section>
    <Loading v-else />
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import ArticleCard from "@/components/cards/article/Index.vue";
import Loading from "@/components/widgets/Loading.vue";
import { formatToURL } from "@/components/utils";

const _config = {
  itemsPerPage: 5,
};

export default {
  data: () => ({
    loading: true,
    items: [],
  }),
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    categories() {
      return this.$rest("articles-categories").list.map(({ id, title }) => ({
        id,
        title,
        uri: formatToURL(title),
      }));
    },
    category() {
      return this.categories.find(({ id }) => id === this.categoryId);
    },
  },

  mounted() {
    if (!this.category) return;

    const params = {
      itemsPerPage: _config.itemsPerPage,
      category: this.category.id,
    };

    if (this.$route.query["data-atual"])
      params.todayDate = this.$route.query["data-atual"];

    this.loading = true;

    this.$rest("articles")
      .get({ params })
      .then((data) => {
        this.items = data;
        this.loading = false;
      });
  },
  components: {
    Title,
    ArticleCard,
    Loading,
  },
};
</script>

<style>
.article-widget-list {
  gap: 16px;
}
</style>
